import { CLAIM_TYPE_CATEGORY } from "../constants/claimTypeCategory";
import { resolveCaseClaimCategory } from "./caseCategoryNavigation";
import {
  fetchCaseDetailsById,
  getCaseDetailsListById,
  getCaseLogsListById,
  saveAssignBackendOfficer,
  saveAssignFieldOfficer,
  saveCaseDocuments,
  saveCaseGeneratedData,
  saveCaseRating,
  saveDynamicReportData,
  saveFieldQCStatusReports,
  saveInitialReportDocuments,
  saveInternalTriggerData,
  saveIsClosedReports,
  saveQCStatusReports,
  updateCaseDetailsData,
  updateCaseStatus,
  updatePendingDocument,
  deleteCaseDocument,
  getDynamicReportById,
  revokeAssignFieldOfficer,
  deleteMotorCaseDocument,
  getMotorCaseDetailsListById,
  getMotorCaseLogsListById,
  getMotorDynamicReportById,
  revokeMotorAssignFieldOfficer,
  saveMotorAssignBackendOfficer,
  saveMotorAssignFieldOfficer,
  saveMotorCaseDocuments,
  saveMotorCaseGeneratedData,
  saveMotorCaseRating,
  saveMotorDynamicReportData,
  saveMotorFieldQCStatusReports,
  saveMotorInitialReportDocuments,
  saveMotorInternalTriggerData,
  saveMotorIsClosedReports,
  saveMotorQCStatusReports,
  updateMotorCaseDetailsData,
  updateMotorCaseStatus,
  updateMotorPendingDocument,
} from "../redux/actions/CaseDetailsActions";

export const isMotorCasePath = (pathname = "") =>
  resolveCaseClaimCategory(pathname) === CLAIM_TYPE_CATEGORY.MOTOR;

const HEALTH_ACTIONS = {
  fetchCaseDetailsById,
  getCaseDetailsListById,
  getCaseLogsListById,
  saveCaseDocuments,
  deleteCaseDocument,
  saveAssignFieldOfficer,
  revokeAssignFieldOfficer,
  saveAssignBackendOfficer,
  saveInitialReportDocuments,
  saveQCStatusReports,
  saveFieldQCStatusReports,
  saveIsClosedReports,
  updateCaseStatus,
  saveCaseRating,
  saveInternalTriggerData,
  getDynamicReportById,
  saveDynamicReportData,
  saveCaseGeneratedData,
  updateCaseDetailsData,
  updatePendingDocument,
};

const MOTOR_ACTIONS = {
  fetchCaseDetailsById,
  getCaseDetailsListById: getMotorCaseDetailsListById,
  getCaseLogsListById: getMotorCaseLogsListById,
  saveCaseDocuments: saveMotorCaseDocuments,
  deleteCaseDocument: deleteMotorCaseDocument,
  saveAssignFieldOfficer: saveMotorAssignFieldOfficer,
  revokeAssignFieldOfficer: revokeMotorAssignFieldOfficer,
  saveAssignBackendOfficer: saveMotorAssignBackendOfficer,
  saveInitialReportDocuments: saveMotorInitialReportDocuments,
  saveQCStatusReports: saveMotorQCStatusReports,
  saveFieldQCStatusReports: saveMotorFieldQCStatusReports,
  saveIsClosedReports: saveMotorIsClosedReports,
  updateCaseStatus: updateMotorCaseStatus,
  saveCaseRating: saveMotorCaseRating,
  saveInternalTriggerData: saveMotorInternalTriggerData,
  getDynamicReportById: getMotorDynamicReportById,
  saveDynamicReportData: saveMotorDynamicReportData,
  saveCaseGeneratedData: saveMotorCaseGeneratedData,
  updateCaseDetailsData: updateMotorCaseDetailsData,
  updatePendingDocument: updateMotorPendingDocument,
};

export const getCaseDetailsActions = (pathname = "") =>
  isMotorCasePath(pathname) ? MOTOR_ACTIONS : HEALTH_ACTIONS;

export const pickCaseDetailsState = (reducer = {}, pathname = "") => {
  const isMotor = isMotorCasePath(pathname);

  return {
    isMotor,
    caseDetailsLists: isMotor ? reducer.motorCaseDetailsLists : reducer.caseDetailsLists,
    loadingCaseDetails: isMotor ? reducer.loadingMotorCaseDetails : reducer.loadingCaseDetails,
    errorsCaseDetails: isMotor ? reducer.errorsMotorCaseDetails : reducer.errorsCaseDetails,
    changedCaseDetailsStatus: isMotor
      ? reducer.changedMotorCaseDetailsStatus
      : reducer.changedCaseDetailsStatus,
    caseLogsLists: isMotor ? reducer.motorCaseLogsLists : reducer.caseLogsLists,
    dynamicReportStatus: isMotor ? reducer.motorDynamicReportStatus : reducer.dynamicReportStatus,
    resetStatusType: isMotor
      ? "RESET_MOTOR_CASE_DETAILS_STATUS"
      : "RESET_DELETE_CASE_DETAILS_STATUS",
    clearDynamicReportType: isMotor
      ? "CLEAR_MOTOR_DYNAMIC_REPORT_STATUS"
      : "CLEAR_DYNAMIC_REPORT_STATUS",
  };
};
